/**
 * Author: Lin-Haiming
 * Email: undefined.bug@foxmail.com
 * Date: 2021/10/27 18:12
 */

import axios from 'axios'

var Request = {}


Request.headers = function (bool) {
	var token = sessionStorage.getItem("token")
	return {
		token,

	}

}

//Request.ajaxUrl = 'http://homework.test.net'
//Request.ajaxUrl = 'http://homework.zeonyu.com'
Request.ajaxUrl = 'https://www.huizuoye.net'
// Request.ajaxUrl1 = 'http://localhost:8080'
Request.ajax = function (vm, status = true, header = true) {
	let axiosInstance = axios.create({
		baseURL: Request.ajaxUrl,
		timeout: 30000,
		headers: Request.headers(header)
	});
	// 添加一个响应拦截器
	axiosInstance.interceptors.response.use(function (res) {
		Request.currentRequest = '';
		if (res.data) {
			return res.data
		}
		if (res.data.status != 1) {
			vm.$message.error(res.data.msg);
			console.log(res.data.msg)
			if (status) return Promise.reject(res.data.msg)
		}
		let data = res.data.data
		if ((typeof data == 'object' && data.length == 0) && (res.data.status == 1) && res.data.msg != 'success') {
			vm.$message.success(res.data.msg);
		}
		/*if (!res.data.data && res.data.status == 1) {
			vm.$notify.success({ title: '成功', message: res.data.msg});
		}*/

		return res.data

	}, function (e) {

		if (!status) return false;

		if (!e.response) return false

		Request.currentRequest = '';

		if (typeof (e) === 'string') {
			vm.$message.info(e)
		} else if (e.response.status == 401) {
			//window.location.href='#/login'
			vm.$store.commit('logout'); //退出登录清空vuex和存储信息
			vm.$router.replace({path: '/loginOne'}); //跳转至选择老师学生
			// sessionStorage.removeItem('token')
			vm.$notify.error({title: '登录已失效', message: '请重新登录'});
		} else if (e.response.status == 403) {
			vm.$message.info('你没有权限');
			vm.$store.commit('logout'); //退出登录清空vuex和存储信息
			vm.$router.replace({path: '/loginOne'}); //跳转至选择老师学生
			// sessionStorage.removeItem('token')
		} else if (e.response.status == 500) {
			vm.$notify.error({title: '请求失败', message: '服务器错误'});
		} else {
			vm.$notify.info({title: '请求失败', message: '网络错误'});
		}
		return Promise.reject(e.response); // promise reject这里可以被后面执行到的catch到错误
	});
	return axiosInstance;
}

export default Request;



// WEBPACK FOOTER //
// ./src/api/request.js